<template>
    <div>
        <div style="height: 20px; background-color: transparent; text-align: right; padding-right: 5%; ">
            <!--<el-button type="info" :icon="isCollapse ? 'Expand':'Fold'" circle link size="small" @click="isCollapse=!isCollapse"></el-button>-->
        </div>
        <el-menu ref='menu'
                 class="el-menu-vertical-demo"
                 active-text-color="#00B8DE"
                 background-color="transparent"
                 text-color="#353839"
                 :default-active="$route.path"
                 @select="handleSelect"
                 :collapse="isCollapse"
                 style="border: 0;">
            <template  v-for="menu in menus">
                <template v-if="menu.ITEMS == null">
                    <el-menu-item :key="menu.URL_ADDR"
                                  :index="menu.URL_ADDR+'|'+menu.TAB_CHI_TITLE">
                        <el-icon><component :is="menu.URL_PARAM" /></el-icon>
                        {{menu.CHI_DESC}}
                    </el-menu-item>
                </template>
                <template v-else>
                    <el-sub-menu :key="menu.FUNC_ID"
                                 :index="menu.FUNC_ID">
                        <template #title>
                            <el-icon><component :is="menu.URL_PARAM" /></el-icon>
                            <span>{{menu.CHI_DESC}}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-for="item in menu.ITEMS"
                                          :key="item.URL_ADDR"
                                          :index="item.URL_ADDR+'|'+item.TAB_CHI_TITLE">
                                {{item.CHI_DESC}}
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-sub-menu>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script setup>
    import { ref, reactive, computed, onMounted, nextTick } from 'vue';
    import axios from "axios";
    import $api from '@/utils/axios';

    import { useStore } from "vuex";
    const store = useStore();
    import { useRouter } from 'vue-router'
    const router = useRouter();

    const menus = ref([]);
    const isCollapse = ref(false);
    const options = computed(() => store.state.options);

    const getMenus = () => {
        $api.GET('/api/Home/GetMenus', {
            root: 'Root', type: 'WEB'
        }).then((response) => {
            menus.value = response;
        }).catch((err) => {
            console.log(err);
        });
    }

    const getAuth = () => {
        store.commit('get_page_auth');
    }

    const handleSelect = (key, path) => {
        console.log('handleSelect');
        var addr = key.split('|')[0];
        var title = key.split('|')[1];
        let index = store.state.options.findIndex(x => x.route == addr);
        if (index > -1) {
            store.commit('save_index', addr);
            store.commit('set_active_index', addr);
        } else {
            store.commit('add_tabs', { route: addr, name: title });
            store.commit('save_index', addr);
            store.commit('set_active_index', addr);
        }

        //紀錄操作Log
        $api.POST('/api/Home/EventLog', addr
        ).then((res) => { });
    }
    onMounted(() => {
        getMenus();
        getAuth();
    });
    //暴露handleSelect方法給父組件呼叫
    defineExpose({ handleSelect});
</script>
<style>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
    }

    li.el-menu-item:hover {
        background-color: #FFFFFF;
        color: #00B8DE;
    }

    li.el-menu-item.is-active {
        background-color: #FFFFFF;
    }
</style>